export default __webpack_public_path__ + "static/cashflow_new_4-d563ce6ec86a2b6d416330362c21cdf8.jpg";